import _ from 'lodash';
const application = [];

import accessControlRoutes from "@accessControlSrc/router/components"
import connectedAccountsRoutes from "@frontendSrc/router/components"

let components = _.merge(application, accessControlRoutes, connectedAccountsRoutes);

export default components;
